// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__3otnz","footer":"ReportModalFilter_footer__EcEW7"};